import {React,useEffect} from 'react'

import { observer } from 'mobx-react'
import { Route, Routes,useNavigate } from 'react-router-dom' 

import { LOGIN_PROVIDER, ROUTES } from 'definitions'
import AuthenticatedRoute from 'components/Core/AuthenticatedRoute'
import AuthWrapper from 'components/Core/AuthWrapper'
import GlobalErrorHandler from 'components/Core/GlobalErrorHandler'
import LoginLayout from 'common/LoginLayout'
import MainLayout from 'common/MainLayout'
import PublicLayout from 'common/PublicLayout'

import OidcLogin from 'components/Login/OidcLogin'
import Saml2Login from 'components/Login/Saml2Login'

import CaseDetail from 'components/Case/CaseDetail'
import Cases from 'components/Case/CaseList'
import ConnectionCarts from 'components/Connection/ConnectionsCarts'
import ConnectionList from 'components/Connection/ConnectionList'
import Feedback from 'components/Feedback'
import Forbidden from 'components/Forbidden'
import Home from 'components/Home'
import LandingPage from 'components/LandingPage'
import Login from 'components/Login'
import News from 'components/News'
import Offline from 'components/Offline'
import Overbill from 'components/Overbill'
import PageNotFound from 'components/PageNotFound'
import PraList from 'components/Pra/PraList'
import PendingAction from 'components/PendingAction'
import ResetPassword from 'components/ResetPassword'
import Suppliers from 'components/Suppliers'
import Webform from 'components/Webform'
import {
  WebshopCart,
  WebshopCatalog,
  WebshopFavourites,
  WebshopHome,
  WebshopProductDetail,
  WebshopSearch,
  WebshopLayout,
  WebshopCatalogLayout,
} from 'WebshopLoader'
import SharedProposal from 'components/SharedProposal'

const App = () => {

 const navigate = useNavigate()

useEffect(() => {
  const params = new URLSearchParams(window.location.search)
  const sharedKey = params.get('sharedKey')

  if (sharedKey) {
    navigate(`/a/${sharedKey}`, { replace: true })
  }
}, [navigate])

  return (
    <GlobalErrorHandler isApp>
      <Routes>
        <Route path={ROUTES.OFFLINE} element={<Offline />} />
        <Route element={<PublicLayout />}>
          <Route path={ROUTES.FEEDBACK} element={<Feedback />} />
          <Route path={`${ROUTES.OVERBILL}/:id`} element={<Overbill />} />
          <Route path={ROUTES.SHARED_PROPOSAL} element={<SharedProposal />} />
        </Route>
        <Route element={<AuthWrapper />}>
          <Route element={<LoginLayout />}>
            <Route path={ROUTES.LOGIN} element={<Login />} />
            <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
            <Route path={ROUTES.LOGIN_AUTOSPHERE} element={<OidcLogin loginProvider={LOGIN_PROVIDER.AUTOSPHERE} />} />
            <Route path={ROUTES.LOGIN_ARGENTA} element={<OidcLogin loginProvider={LOGIN_PROVIDER.ARGENTA} />} />
            <Route path={ROUTES.LOGIN_BELFIUS} element={<Saml2Login loginProvider={LOGIN_PROVIDER.BELFIUS} />} />
            <Route path={ROUTES.LOGIN_GOED} element={<Saml2Login loginProvider={LOGIN_PROVIDER.GOED} />} />
            <Route
              path={ROUTES.LOGIN_INTERPARKING}
              element={<OidcLogin loginProvider={LOGIN_PROVIDER.INTERPARKING} />}
            />
            <Route path={ROUTES.LOGIN_NUNHEMS} element={<Saml2Login loginProvider={LOGIN_PROVIDER.NUNHEMS} />} />
          </Route>
          <Route element={<MainLayout />}>
            <Route element={<AuthenticatedRoute />}>
              <Route path={ROUTES.DEFAULT} element={<LandingPage />} />
              <Route path={ROUTES.HOME} element={<Home />} />
              <Route path={ROUTES.WEBFORM} element={<Webform />} />
              <Route path={ROUTES.CASES} element={<Cases />} />
              <Route path={`${ROUTES.CASES}/:id/:tab`} element={<CaseDetail />} />
              <Route path={`${ROUTES.CASES}/:id`} element={<CaseDetail />} />
              <Route path={ROUTES.SUPPLIERS} element={<Suppliers />} />
              <Route path={ROUTES.PRA} element={<PraList />} />
              <Route path={ROUTES.NEWS} element={<News />} />
              <Route element={<WebshopLayout />}>
                <Route path={ROUTES.WEBSHOP} element={<WebshopHome />} />
                <Route path={ROUTES.WEBSHOP_CART} element={<WebshopCart />} />
                <Route path={ROUTES.WEBSHOP_FAVOURITES} element={<WebshopFavourites />} />
                <Route path={`${ROUTES.WEBSHOP_PRODUCT}/:id`} element={<WebshopProductDetail />} />
                <Route element={<WebshopCatalogLayout />}>
                  <Route path={ROUTES.WEBSHOP_SEARCH} element={<WebshopSearch />} />
                  <Route path={`${ROUTES.WEBSHOP_CATALOG}/*`} element={<WebshopCatalog />} />
                  <Route path={`${ROUTES.WEBSHOP_PRODUCT}`} element={<PageNotFound />} />
                </Route>
              </Route>
              <Route path={ROUTES.CONNECTIONS} element={<ConnectionList />} />
              <Route path={ROUTES.CONNECTIONS_CART} element={<ConnectionCarts />} />
              <Route path={ROUTES.PENDING_ACTION} element={<PendingAction />} />
            </Route>
            <Route path={ROUTES.FORBIDDEN} element={<Forbidden />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Route>
      </Routes>
    </GlobalErrorHandler>
  )
}

export default observer(App)
